import styled from 'styled-components';
import { ContainerV2 } from '../../../stories/atoms/containerV2/ContainerV2';

export const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { spacing } }) => spacing(3)};
`;

export const SummaryWidgetsContainer = styled(ContainerV2)<{ isMobile: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme: { spacing } }) => spacing(3)};
  justify-content: flex-start;
  ${({ isMobile, theme: { spacing } }) =>
    isMobile
      ? `
        > * {
          min-width: 0;
          flex: 0 0 calc((100% - (${spacing(3)} * 2)) / 3);
        }

        > :nth-child(n + 4) {
          flex: 0 0 calc((100% - ${spacing(3)}) / 2);
        }
      `
      : `
        > * {
          flex:1;
        }
      `}
`;

export const OverviewWidgetsContainer = styled(ContainerV2)<{
  isMobile: boolean;
  isSmallDesktop: boolean;
}>`
  display: grid;
  gap: 1rem;

  grid-template-columns: ${({ isMobile, isSmallDesktop }) =>
    isMobile ? 'repeat(1, 1fr)' : isSmallDesktop ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)'};
`;
